















import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import requests from '@/helpers/requests'


enum State {
    READY,
    LOADING,
    SUCCESS,
    ERROR
}


interface LocationData {
    name: string;
}


@Component({})
export default class AccountIdInput extends Vue {
    @Prop({ default: false }) value!: string|number|null
    @Prop({ default: false }) disabled!: boolean
    @Prop({ default: false }) loading!: boolean

    message: string|null = null
    state: State = State.READY
    locationData: LocationData|null = null
    timeout: number|null = null

    /**
     * Handle the newest input. If the new input is valid, do an asynchronous location lookup.
     * @param newValue
     * @emits input
     */
    @Emit('input')
    onInput(newValue: string): number|null {
        this.resetState()
        let value = null
        if (newValue !== '') {
            const intValue = parseInt(newValue)
            if (!isNaN(intValue)) {
                value = intValue
                // Wait 500ms seconds and perform a lookup.
                this.timeout = setTimeout(this.loadAccount.bind(this, value), 500)
            }
        }
        return value
    }

    resetState() {
        if (this.timeout !== null) {
            clearTimeout(this.timeout)
        }
        this.state = State.READY
        this.message = null
        this.updateLocationData(null)
    }

    async loadAccount(pulsemAccountId: number) {
        // this.state = State.LOADING // This causes the input to lose focus.
        this.message = null
        this.updateLocationData(null)
        try {
            const response = await requests.post('/support/internal/location/fetch', {
                pulsemAccountId
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }) as any
            this.state = State.SUCCESS
            this.updateLocationData(response.data)
        } catch(e) {
            this.state = State.ERROR
            this.message = e.message
            this.updateLocationData(null)
        }
        return this.successState
    }

    @Emit('onStateChange')
    updateLocationData(newLocationData: LocationData|null) {
        this.locationData = newLocationData
        return this.successState
    }

    get locationName(): null|string {
        if (this.locationData) {
            return this.locationData.name
        } else {
            return null
        }
    }

    get errorState(): boolean {
        return this.state === State.ERROR
    }

    get loadingState(): boolean {
        return this.state === State.LOADING
    }

    get successState(): boolean {
        return this.state === State.SUCCESS
    }
}
